var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseSlice',{staticClass:"gst-slice-spacer",attrs:{"slice-type":_vm.slice.slice_type,"slice-index":_vm.slice.index,"full-width":""}},[_c('div',{style:(_vm.style)})])}
var staticRenderFns = []

export { render, staticRenderFns }